
define( 'FORCES_AND_MOTION_BASICS/../nls/pt-br/forces-and-motion-basics-strings',{
          "none": "Nenhum",
          "force": "Força",
          "values": "Valores",
          "frictionTitle": "Atrito",
          "redWins": "Vermelho Vence!",
          "frictionForce": "Força de Atrito",
          "pause": "Parar",
          "friction": "Atrito",
          "forces-and-motion-basics.name": "Forças e Movimentos: Noções Básicas",
          "appliedForce": "Força Aplicada",
          "leftForce": "Força para a Esquerda",
          "massDisplay.pattern": "{0} kg",
          "rightForce": "Força para a Direita",
          "sound": "Som",
          "lots": "Muito",
          "forces": "Forças",
          "motion": "Movimento",
          "tugOfWar": "Cabo de Guerra",
          "go": "Iniciar!",
          "newtons.n": "Newtons (N)",
          "sumOfForcesEqualsZero": "Soma das Forças = 0",
          "blueWins": "Azul Vence!",
          "speed": "Velocidade",
          "sumOfForces": "Soma das Forças",
          "return": "Voltar",
          "translation.credits": "Francislâiny Campos",
          "newtons": "Newtons",
          "masses": "Massas",
          "forceReadout.pattern": "{0}N"
        } );